import jwt_decode from "jwt-decode";
import { AppStorage } from "../http/helpers/AppStorage.js";
const customerAuthTokenName = "customer";
const customerAuthData = "customer_data";
const customerAuthDate = "customer_date";
const tokenAction = {
  add: (token) => {
    let customerData = null;
    try {
      customerData = jwt_decode(token.token);
    } catch (e) {
      console.error("some error with token", e);
      return {
        success: false,
        error: e
      };
    }
    AppStorage.set(customerAuthTokenName, token);
    AppStorage.set(customerAuthData, customerData);
    AppStorage.set(
      customerAuthDate,
      AppStorage.get(customerAuthDate) ? AppStorage.get(customerAuthDate) : /* @__PURE__ */ new Date()
    );
    return {
      success: true
    };
  },
  remove: () => {
    AppStorage.remove(customerAuthTokenName);
    AppStorage.remove(customerAuthData);
    AppStorage.remove(customerAuthDate);
  },
  getData: () => ({
    token: AppStorage.get(customerAuthTokenName),
    customerData: AppStorage.get(customerAuthData),
    customerSessionDate: AppStorage.get(customerAuthDate)
  })
};
export {
  customerAuthData,
  customerAuthDate,
  customerAuthTokenName,
  tokenAction
};
